import fetch from '@/utils/fetch'

export function getInfo () {
  return fetch({
    url: '/ows/member/personalCenter',
    method: 'post'
  })
}

export function saveObj (data) {
  return fetch({
    url: '/ows/member/modifyMember',
    method: 'post',
    data
  })
}
export function updateUserPassword (data) {
  return fetch({
    url: '/ows/member/modifyPersonalPassword',
    method: 'post',
    data
  })
}
export function updateMobile (data) {
  return fetch({
    url: '/ows/member/modifyPhone',
    method: 'post',
    data
  })
}
